var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaxes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_20639",
    "data-name": "Group 20639",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.511,
    height: 20.175,
    viewBox: "0 0 19.511 20.175",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_20712",
    "data-name": "Path 20712",
    d: "M2.082,1.14H13.325a3.378,3.378,0,0,1,3.369,3.369V15.173H1.727V1.14h.355Zm11.243.71H2.437V14.463H15.984V4.509A2.668,2.668,0,0,0,13.325,1.85Z",
    transform: "translate(0.545 -1.14)",
    fill: "#363636"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_20713",
    "data-name": "Path 20713",
    d: "M20.37,10.994H1.215V4.143H20.725v6.851Zm-18.446-.71H20.015V4.853H1.925Z",
    transform: "translate(-1.215 9.181)",
    fill: "#363636"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_20714",
    "data-name": "Path 20714",
    d: "M2.292,2.112h9.952v.71H2.292Z",
    transform: "translate(2.487 2.201)",
    fill: "#363636"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_20715",
    "data-name": "Path 20715",
    d: "M2.292,2.675h9.952v.71H2.292Z",
    transform: "translate(2.487 4.134)",
    fill: "#363636"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_20716",
    "data-name": "Path 20716",
    d: "M2.292,3.237h9.952v.71H2.292Z",
    transform: "translate(2.487 6.068)",
    fill: "#363636"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_20717",
    "data-name": "Path 20717",
    d: "M2.144,4.5H5.6v.91H4.443V8.184H3.3V5.41H2.144ZM8.036,7.575h-1.3l-.178.608H5.4L6.782,4.5H8.023L9.409,8.184H8.217Zm-.238-.8L7.39,5.454l-.4,1.324ZM9.519,4.5h1.253l.654,1.133L12.059,4.5H13.3L12.155,6.284l1.254,1.9H12.13L11.4,7l-.729,1.184H9.4l1.271-1.92L9.519,4.5Z",
    transform: "translate(1.979 10.407)",
    fill: "#363636"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxes);
export default __webpack_public_path__ + "static/media/Taxes.784b96db4c30f6c277a24b3548ca6f1d.svg";
export { ForwardRef as ReactComponent };